import { formatDistanceToNow } from "date-fns";
import { Card, Icon, IconButton, Tooltip } from "@/components/atoms";
import { useAppDispatch } from "@/redux/hooks";
import { setAction } from "@/redux/slices/booking/bookingSlice";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../common/DetailField";

interface HistorySectionProps {
  booking: BookingDetails;
}

export const HistorySection = ({ booking }: HistorySectionProps) => {
  const dispatch = useAppDispatch();
  const { history } = booking;

  const getHistoryValue = () => {
    if (!history?.lastUpdated) {
      return "No history available";
    }

    try {
      const lastUpdated = new Date(history.lastUpdated);
      return `Updated ${formatDistanceToNow(lastUpdated, { addSuffix: true })}`;
    } catch {
      return "Invalid date";
    }
  };

  return (
    <Card className="p-2.5">
      <DetailField
        leading={<Icon name="CalendarCircle" size="lg" className="text-neutral-dark-gray" />}
        label="History"
        value={getHistoryValue()}
        right={
          <Tooltip content="View Job History" placement="top">
            <IconButton
              iconName="ArrowRight"
              iconSize="md"
              size="xs"
              variant="primary"
              className="h-8 w-8"
              onClick={() => dispatch(setAction("job-history"))}
            />
          </Tooltip>
        }
      />
    </Card>
  );
};
